export default "__VITE_ASSET__D_D6iVLD__"